import type {Messages} from "../catalogue.en";
// Repeatable title-sheet facts and document reconciliation.
export const patientTitleSheet: Partial<Messages> = {
  "patient.death.mergeMismatch": "תאריכי הפטירה בתיקים שונים. יש לתקן אותם בדפי הפרטים לפני מיזוג התיקים.",
  "patient.death.label": "המטופל נפטר",
  "patient.death.date": "תאריך פטירה",
  "patient.death.edit": "רישום או תיקון פרטי פטירה",
  "patient.death.readOnly": "המטופל נפטר. לא ניתן להוסיף או לשנות מפגשים, פרוטוקולים ואבחנות.",
  "patient.death.dateRequired": "יש להזין תאריך פטירה.",
  "patient.death.reason": "סיבת התיקון",
  "patient.death.reasonRequired": "יש לציין סיבה לתיקון פרטי הפטירה.",
  "patient.death.invalid": "יש לבדוק את תאריך הפטירה ולציין סיבה לתיקון.",
  "patient.death.unsaved": "שינויים שלא נשמרו בפרטי פטירת המטופל",
  "patient.death.age": "גיל בעת הפטירה",

  "patient.facts.address.useManual": "מעבר להזנה ידנית",
  "patient.facts.address.manualWarning": "כתובת ידנית — אינה מתאימה לחילופי נתוני כתובות אוטומטיים.",
  "patient.facts.address.registryMethod": "הכתובת נבחרה ממרשם כתובות",

  "patient.facts.addresses": "כתובות",
  "patient.facts.edit.addresses": "עריכת כתובות",
  "patient.facts.history.addresses": "היסטוריית כתובות",
  "patient.facts.address.text": "הכתובת המלאה כפי שנרשמה",
  "patient.facts.address.components": "רכיבי הכתובת",
  "patient.facts.address.componentsHint": "לא חובה. יש למלא את הרכיבים המתאימים לכתובת ולוודא שהכתובת המלאה למעלה תואמת להם.",
  "patient.facts.address.registryText": "הכתובת המלאה מהמרשם",
  "patient.facts.address.gar": "בחירה ממרשם הכתובות GAR",
  "patient.facts.address.garLoading": "טעינת כתובות…",
  "patient.facts.address.garUnavailable": "מרשם הכתובות אינו זמין. אפשר להמשיך להזין את הכתובת ידנית.",
  "patient.facts.address.garQuery": "עיר, רחוב או מספר",
  "patient.facts.address.garSearch": "חיפוש כתובת",
  "patient.facts.address.garReset": "חיפוש בכל הכתובות",
  "patient.facts.address.garFailure": "לא ניתן לטעון את הכתובת. הטיוטה נשמרה; נסו לחפש שוב.",
  "patient.facts.address.garEmpty": "לא נמצאו כתובות.",
  "patient.facts.address.garChildren": "בחירת רחוב, בית או דירה בתוך הכתובת",
  "patient.facts.address.garSelect": "שימוש בכתובת זו",
  "patient.facts.address.garStale": "הבחירה אינה זמינה עוד במרשם. יש לבחור שוב את הכתובת; הטיוטה נשמרה.",
  "patient.facts.address.region": "אזור / מדינה / מחוז",
  "patient.facts.address.district": "נפה / אזור משנה",
  "patient.facts.address.locality": "עיר / יישוב",
  "patient.facts.address.localityType": "סוג היישוב",
  "patient.facts.address.street": "רחוב",
  "patient.facts.address.house": "מספר / שם הבית",
  "patient.facts.address.building": "בניין / אגף",
  "patient.facts.address.unit": "דירה / יחידה",
  "patient.facts.address.postalCode": "מיקוד",
  "patient.facts.address.purpose.unspecified": "לא צוין",
  "patient.facts.address.purpose.home": "מגורים בפועל",
  "patient.facts.address.purpose.registration": "כתובת רשומה",
  "patient.facts.address.purpose.temporary": "מגורים זמניים",
  "patient.facts.address.purpose.postal": "כתובת למשלוח דואר",
  "patient.facts.address.purpose.work": "כתובת עבודה",
  "patient.facts.address.purpose.other": "אחר",
  "patient.facts.address.state.current": "נוכחית",
  "patient.facts.address.state.former": "קודמת",
  "patient.facts.address.state.unspecified": "לא צוין",

  "patient.identity.countryOption": "{action} {state} ({start}–{end})",
  "patient.identity.sourceChanged": "הקבצים השתנו לאחר הזיהוי. יש לזהות אותם שוב לפני השמירה; הטיוטה נשמרה.",
  "patient.identity.addCitizenship": "הוספת אזרחות",
  "patient.identity.addResidence": "הוספת מדינת מגורים",
  "patient.identity.addName": "הוספת גרסת שם",
  "patient.identity.printedNames": "שמות המופיעים במסמך",
  "patient.identity.permitCountry": "המדינה שהעניקה היתר שהייה",
  "patient.identity.permitHint": "היתר אינו קובע מקום מגורים רגיל. יש לאשר את המגורים ואת התקופה בנפרד.",
  "patient.identity.compare": "השוואה לתיק המטופל",
  "patient.identity.selectionHint": "יש לבחור רק את השינויים הרצויים. שמירת המסמך בלבד אינה משנה את פרטי המטופל.",
  "patient.identity.same": "כבר רשום",
  "patient.identity.countryAction": "הוספה או קישור של רישום מדינה",
  "patient.identity.newPeriod": "הוספת תקופה חדשה",
  "patient.identity.add": "הוספת רישום",
  "patient.identity.link": "קישור ועדכון הרישום הקיים",
  "patient.identity.nameAction": "הוספה או תיקון של שם",
  "patient.identity.formerNameEnd": "בשינוי שם בפועל: היום האחרון לשימוש בשם הקודם. לתיקון בלבד יש להשאיר ריק.",
  "patient.identity.nameAmbiguous": "יש לבדוק את גרסאות השם ולבחור את הכתיב המועדף לפני החלת השינוי.",
  "patient.identity.resultingName": "השם שיוצג לאחר השינוי",
  "patient.identity.acceptName": "אני מאשר/ת את השם שיוצג",
  "patient.identity.applyRotation": "החלת כיוון העמוד לפי Google",
  "patient.identity.conflict": "המסמך או פרטי המטופל השתנו. הטיוטה נשמרת בטופס; יש לטעון את המסמך השמור או להשוות שוב לפרטי המטופל.",
  "patient.identity.recompare": "קריאת פרטי המטופל העדכניים והשוואה מחדש",
  "patient.identity.recompared": "הנתונים העדכניים נטענו. יש לבדוק ולבחור את השינויים מחדש.",
  "patient.identity.countryExists": "כבר קיים רישום מתמשך למדינה זו. יש לבחור בו לקישור או לעדכון.",
  "patient.identity.primaryExists": "פוליסה אחרת כבר מוגדרת כראשית. יש לאשר במפורש את השינוי.",
  "patient.identity.replaceDraft": "לבצע זיהוי מחדש ולהחליף את שדות הטיוטה?",
  "patient.identity.replaceDraftDetail": "הזיהוי יחליף את שדות המסמך שהוזנו. פרטי המטופל ישתנו רק לאחר בחירה והחלה של השינויים.",
  "patient.identity.insuranceRole": "תפקיד הפוליסה",
  "patient.identity.role.primary": "ראשית",
  "patient.identity.role.secondary": "משנית",
  "patient.identity.reassignPrimary": "הפיכת הפוליסה הראשית הקיימת הבאה למשנית:",
  "patient.identity.insurerPhone": "טלפון חברת הביטוח",
  "patient.identity.insurerEmail": "דוא״ל חברת הביטוח",
  "patient.identity.assistanceName": "שירות סיוע",
  "patient.identity.assistancePhone": "טלפון שירות הסיוע",
  "patient.identity.assistanceEmail": "דוא״ל שירות הסיוע",
  "patient.identity.errorReason": "סיבה לסימון הרישום כשגוי",
  "patient.identity.requisites": "פרטי המסמך",
  "patient.identity.policyRequisites": "פרטי הפוליסה",
  "patient.identity.moreRequisites": "עוד",
  "patient.identity.moreRequisitesTitle": "תאריך ההנפקה והרשות המנפיקה",
  "patient.identity.documentData": "הנתונים שבמסמך",
  "patient.identity.furtherCitizenship": "אזרחות נוספת",
  "patient.identity.permitBrief": "היתר שהייה",
  "patient.identity.refine": "פירוט",
  "patient.identity.countriesTitle": "אזרחות, מגורים והיתר שהייה",
  "patient.identity.done": "סיום",
  "patient.identity.spellings": "כתיבים: {count}",
  "patient.identity.languageUnknown": "השפה לא צוינה",
  "patient.identity.international": "בינלאומי",
  "patient.identity.editName": "עריכת השם {name}",
  "patient.identity.nameInDocument": "השם במסמך",
  "patient.identity.sourceDocument": "מסמך המקור",
  "patient.identity.sourceFiles": "קבצים: {count}",
  "patient.identity.enlarge": "הגדלה",
  "patient.identity.windowTabs": "חלקי חלון המסמך",
  "patient.identity.tabFields": "פרטים ונתונים",
  "patient.identity.tabChanges": "שינויים בתיק המטופל",
  "patient.identity.pickedOf": "{selected}/{total}",
  "patient.identity.currentChart": "תיק המטופל הנוכחי",
  "patient.identity.transferOf": "אופן ההעברה: {name}",
  "patient.identity.documentOnly": "המסמך בלבד",
  "patient.identity.saveAndApply": "שמירה והחלה · {count}",
  "patient.identity.pickedCount": "שינויים שנבחרו: {count}",
  "patient.identity.chartUnchanged": "תיק המטופל יישאר ללא שינוי",
  "patient.identity.checkBeforeSaving": "יש להשוות את הערכים לסריקה לפני השמירה.",
  "patient.identity.erroneousHolds": "רשומה שסומנה כשגויה אינה משנה את תיק המטופל. יש לשמור את המסמך בלבד.",
  "patient.identity.acceptHolds": "יש לאשר את השם המוצג בלשונית השינויים.",
  "patient.facts.country": "מדינה",
  "patient.facts.state": "מצב",
  "patient.facts.state.current": "נוכחי",
  "patient.facts.state.former": "קודם",
  "patient.facts.state.unspecified": "לא צוין",
  "patient.facts.details": "פרטים",
  "patient.facts.start": "מתאריך",
  "patient.facts.end": "עד תאריך",
  "patient.facts.partialDate": "YYYY, YYYY-MM או YYYY-MM-DD",
  "patient.facts.source": "מקור",
  "patient.facts.source.reported": "לפי דיווח",
  "patient.facts.source.document": "מסמך",
  "patient.facts.source.unknown": "לא תועד",
  "patient.facts.document": "מסמך מקור",
  "patient.facts.note": "הערה",
  "patient.facts.erroneous": "הוזן בטעות",
  "patient.facts.citizenships": "אזרחויות",
  "patient.facts.residences": "מקומות מגורים",
  "patient.facts.contacts": "פרטי קשר",
  "patient.facts.removeDraft": "הסרת רשומה חדשה",
  "patient.facts.add": "הוספת רשומה",
  "patient.facts.deliveryInUse": "יש לנתק את ערוץ השליחה המקושר לפני שינוי או הסרת פרטי הקשר.",
  "patient.facts.stale": "הפרטים השתנו בהפעלה אחרת. יש לטעון מחדש את הערכים השמורים לפני עריכה נוספת.",
  "patient.facts.contactType": "סוג פרטי קשר",
  "patient.facts.contactType.phone": "טלפון",
  "patient.facts.contactType.email": "דוא״ל",
  "patient.facts.purpose": "ייעוד",
  "patient.facts.purpose.unspecified": "לא צוין",
  "patient.facts.purpose.personal": "אישי",
  "patient.facts.purpose.work": "עבודה",
  "patient.facts.purpose.travel": "נסיעות",
  "patient.facts.purpose.other": "אחר",
  "patient.facts.preferred": "מועדף",
  "patient.facts.verifiedContact": "פרטי הקשר אומתו",
  "patient.facts.count": "רשומות: {count}",
  "patient.facts.period": "תקופה",
  "patient.facts.former": "רשומות קודמות",
  "patient.facts.older": "גרסאות קודמות",
  "patient.facts.hoursNotEnforced": "שעות השליחה נשמרות, אך הודעות למטופל עדיין אינן מוגבלות לחלון זמן זה.",
  "patient.facts.edit.citizenships": "עריכת אזרחויות",
  "patient.facts.edit.residences": "עריכת מקומות מגורים",
  "patient.facts.edit.contacts": "עריכת פרטי קשר",
  "patient.facts.history.citizenships": "היסטוריה: אזרחויות",
  "patient.facts.history.residences": "היסטוריה: מקומות מגורים",
  "patient.facts.history.contacts": "היסטוריה: פרטי קשר",
  "patient.facts.channels": "ערוצי מסרים",
  "patient.documents.downloadScanNamed": "הורדת סריקה: {name}",
  "patient.documents.editNamed": "עריכת {name}",
  "patient.documents.expiredOn": "התוקף פג ב־{date}",
  "patient.sheet.menu": "דף השער: תצוגה ופעולות",
  "patient.sheet.layout": "תצוגת הדף",
  "patient.sheet.layout.dossier": "תיק אישי",
  "patient.sheet.layout.passport": "דרכון ורצף",
  "patient.sheet.chart": "תיק המטופל",
  "patient.sheet.actsOf": "{part}: פעולות",
  "patient.sheet.actIn": "{act}: {part}",
  "patient.sheet.add": "הוספה",
  "patient.sheet.facts": "עיקרי הפרטים",
  "patient.sheet.fact.age": "גיל",
  "patient.sheet.fact.citizenship": "אזרחות",
  "patient.sheet.fact.residence": "מתגורר/ת ב",
  "patient.sheet.fact.consent": "הסכמה",
  "patient.sheet.basic": "פרטים בסיסיים",
  "patient.sheet.keeping": "ניהול התיק",
  "patient.sheet.contact": "פרט קשר",
  "patient.sheet.marks": "סימונים",
  "patient.sheet.edit.basic": "עריכת פרטים בסיסיים",
  "patient.sheet.edit.registration": "עריכת פרטי הרישום",
  "patient.sheet.messengers.manage": "ניהול ערוצי מסרים",
  "patient.sheet.consent.preview": "תצוגה מקדימה של הטופס",
  "patient.sheet.consent.blank": "הורדת טופס ריק",
  "patient.sheet.consent.signed": "הורדת הטופס החתום",
  "patient.sheet.consent.revoke": "ביטול",
  "patient.documents.noExpiry": "ללא תפוגה",
  "patient.documents.until": "עד {date}",
  "patient.documents.hideExpired": "הסתרת מסמכים שפג תוקפם",
  "patient.documents.showExpiredCount": "הצגת מסמכים שפג תוקפם ({count})",
  "patient.sheet.docs.document": "מסמך",
  "patient.sheet.docs.number": "מספר",
  "patient.sheet.docs.country": "מדינה",
  "patient.sheet.docs.term": "תוקף",
  "patient.sheet.docs.role": "תפקיד",
  "patient.sheet.docs.kind": "סוג",
  "patient.facts.periodBetween": "{start} – {end}",
  "patient.facts.periodSince": "מאז {start}",
  "patient.facts.periodUntil": "עד {end}",
  "patient.facts.formerly": "בעבר:",
  "patient.sheet.channels": "ערוצי תקשורת",
  "patient.sheet.channels.channel": "ערוץ",
  "patient.sheet.channels.address": "כתובת",
  "patient.sheet.channels.messages": "הודעות המרפאה",
  "patient.sheet.channels.allowed": "מותר",
  "patient.sheet.channels.notChosen": "לא נבחר",
  "patient.sheet.channels.blocked": "חסום",
  "patient.sheet.channels.noMessages": "לא נבחרו סוגי הודעות",
  "patient.sheet.channels.links": "יישומי מסרים",
  "patient.sheet.channels.settings": "הגדרות תקשורת",
  "patient.sheet.consentAccepted": "ההסכמה אושרה",
  "patient.sheet.consentMissing": "אין הסכמה",
};
